import { Type } from "class-transformer";
import { BaseModel } from "../base.model";
import { FormInstanceContact } from "../forms/form-instance-contact.model";

export class ScheduledEmail extends BaseModel {
  uuid: string;
  @Type(() => Boolean)
  isPaused: boolean;
  @Type(() => {
    const { FormInstanceContact } = require("../forms/form-instance-contact.model");
    return FormInstanceContact;
  })
  formInstanceContact?: FormInstanceContact;
}
